import React from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

function useApi({ queryFn, meta }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  const fetch = async (params) => {
    try {
      setIsLoading(true);
      const result = await queryFn(params);
      return result.data;
    } catch (error) {
      setIsError(true);
      toast.error(t(meta?.errorMessage));
    } finally {
      setIsLoading(false);
    }
  };

  return { fetch, isLoading, isError };
}

export default useApi;
